import Log from './partial/log'
import Info from './partial/info'
// import goodsList from './partial/goods-list'

export default {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      reviewable:false,
      visible: false,
    }
  },
  methods: {

    init(id , reviewable = false) {
      this.visible = true
      this.reviewable = reviewable
      if (id) {
        this.query(id)
      }
    },

    initByAssociate(id){
      this.reviewable = false
      this.loading = true
      this.$request.approvalInfoQueryByAssociate(id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          this.data = this.$utils.conv(resp.data , {'patrolWarnDatetime':'datetime'})
          this.id = resp.data.id
        }else{
          this.$Message.error({ content: resp.msg })
        }
      })
    },

    query(id) {
      this.loading = true
      this.$request.stdInstallation(id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          
          // resp.data.partsList = this.$utils.conv(resp.data.partsList || [], {'genre':'genre'})
          
          this.data = this.$utils.conv(resp.data , {'assignDatetime':'datetime','reviewDatetime':'datetime','reviewResult':'stdInstallationReviewResult'})

        }else{
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    const title = '安装单 '+data.installNo
    let repairName = data.repairSiteName || ''
    if( data.repairUserName ) repairName += data.repairUserName
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title={title} loading={loading}>
        <Tabs value="t1">
          <TabPane label="基本信息" name="t1">
            <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
             
              <sl-detail-list-item title="企业名称">{data.companyName}</sl-detail-list-item>
              <sl-detail-list-item title="车架号">{data.carFrameNo}</sl-detail-list-item>
              <sl-detail-list-item title="车辆品牌">{data.carBrand}</sl-detail-list-item>
              <sl-detail-list-item title="车辆类型">{data.carCategoryName}</sl-detail-list-item>
              <sl-detail-list-item title="接单站点/人">{repairName}</sl-detail-list-item>
              <sl-detail-list-item title="接单时间">{data.assignDatetimeText}</sl-detail-list-item>
              <sl-detail-list-item title="审核结果">{data.reviewResultText}</sl-detail-list-item>
              <sl-detail-list-item title="审核原因">{data.reviewDesc}</sl-detail-list-item>
              <sl-detail-list-item title="审核时间">{data.reviewDatetimeText}</sl-detail-list-item>
            </sl-detail-list>
          </TabPane>
          {
            this.$a('std.installation.query.detail') ? <TabPane label="安装信息" name="t2">
              <Info data={data} />
            </TabPane> : null
          }
          {
            this.$a('std.installation.query.record') ? <TabPane v-permission="std.installation.query.record" label="维修记录" name="t3">
              <Log style="padding-left:24px;" installation-id={data.id} />
            </TabPane> : null
          }
        </Tabs>

      </sl-side-panel>
    )
  }
}